<!-- DEFINIER COMPONENTE DE FILE -->
<div class="container">
  <div>
    <button
      type="button"
      mat-raised-button
      class="buttton-file-input"
      (click)="fileInput.click()"
    >
      Seleccionar archivo
    </button>
    <input
      hidden
      (change)="capturedFile($event)"
      #fileInput
      type="file"
      id="file"
      accept="image/*"
      formControlName="proImageFile"
    />
  </div>

  <!-- PREVIEW IMAGE -->
  <div *ngIf="previewImage">
    <img [src]="previewImage" width="100px" alt="Vista previa de la imagen" />
  </div>
</div>
